import type { JobMatchingHighlightsV2Fragment } from '@xing-com/crate-jobs-graphql';

import { getMatchingHighlightsFlags } from './matching-highlights';

type GetSimilarJobsArg = {
  matchingHighlights?: JobMatchingHighlightsV2Fragment | null;
  isExternalJobAd: boolean;
};

export const getSimilarJobFlags = ({
  matchingHighlights,
  isExternalJobAd,
}: GetSimilarJobsArg): string | undefined => {
  const matchingHighlightsFlags =
    getMatchingHighlightsFlags(matchingHighlights);
  return matchingHighlightsFlags || isExternalJobAd
    ? `${matchingHighlightsFlags ?? ''}${matchingHighlightsFlags && isExternalJobAd ? ',' : ''}${isExternalJobAd ? 'external_job_ad' : ''}`
    : undefined;
};
